import { render, staticRenderFns } from "./donatur.vue?vue&type=template&id=52693962&scoped=true&"
import script from "./donatur.vue?vue&type=script&lang=js&"
export * from "./donatur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52693962",
  null
  
)

export default component.exports